<template>
    <div class="col-md-4">
        <div class="card card-shadow border-0 mb-4">
            <img class="card-img-top" :src="image" :alt="title" />
            <div class="p-3">
                <h5 class="font-weight-medium mb-0">{{ upperCaseTitle }}</h5>
                <h6 class="subtitle font-13">{{ description }}</h6>
                <ul class="list-inline font-14 mt-3">
                    <li
                        v-for="(feature, index) in features"
                        :key="index"
                        class="py-1"
                    >
                        <i class="icon-arrow-right-circle text-success"></i>
                        {{ feature }}
                    </li>
                </ul>
                <div class="d-flex mt-3 align-items-center">
                    <div class="ml-auto">
                        <router-link
                            v-if="active"
                            :to="{ name: routeTo }"
                            class="btn btn-danger-gradiant rounded-pill text-white btn-md border-0"
                            >{{
                                $t("pages.home.cards.button-text-active")
                            }}</router-link
                        >
                        <a
                            v-else
                            class="btn disabled btn-danger-gradiant rounded-pill text-white btn-md border-0"
                            href=""
                            >{{
                                $t("pages.home.cards.button-text-disabled")
                            }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: String,
        title: String,
        description: String,
        features: Array,
        active: Boolean,
        routeTo: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        upperCaseTitle() {
            return this.title.toUpperCase();
        }
    }
};
</script>
